<footer>
  <div class="footer">
    <span>&copy; {{ currentYear }} Sony Pictures Entertainment Inc. All Rights Reserved.</span>
    <div class="footer__links">
      <a class="footer__link" routerLink="" (click)="showPrefDialog($event)">{{
        'cookie-consent-tool-label' | translate
      }}</a>
      <a class="footer__link" routerLink="/user/contact-us">{{ 'contact-us-label' | translate }}</a>
      <a class="footer__link" href="https://intl.sonypictures.com" target="_blank">{{
        'privacy-policy-label' | translate
      }}</a>
      <a class="footer__link" routerLink="/public/terms_of_use">{{
        'terms-of-use-label' | translate
      }}</a>
      <a class="footer__link" routerLink="/public/additional">{{
        'additional-documents-label' | translate
      }}</a>
    </div>
    <div class="nav">
      <div class="nav--connect">
        <a
          *ngIf="socialMediaLinks?.F || currentTerritoryId === null"
          id="social-1"
          class="nav__link"
          [href]="socialMediaLinks?.F ?? 'https://www.facebook.com/SonyPictures'"
          target="_blank"
          rel="noopener"
          ><span class="icn-facebook sprite-icon"></span
          ><span class="visuallyhidden">Facebook</span></a
        >
        <a
          id="social-2"
          class="nav__link"
          *ngIf="currentTerritoryId === null"
          href="https://www.linkedin.com/company/sony-pictures-entertainment"
          target="_blank"
          rel="noopener"
          ><span class="icn-linkedin sprite-icon"></span
          ><span class="visuallyhidden">LinkedIn</span></a
        >
        <a
          id="social-3"
          class="nav__link"
          [href]="socialMediaLinks?.TW ?? 'https://x.com/SonyPictures'"
          target="_blank"
          rel="noopener" 
          ><i title="X" class="fa-brands fa-x-twitter"></i></a
        >
        <a
          *ngIf="socialMediaLinks?.I || currentTerritoryId === null"
          id="social-4"
          class="nav__link"
          [href]="socialMediaLinks?.I ?? 'https://www.instagram.com/SonyPictures/'"
          target="_blank"
          rel="noopener"
          ><span class="icn-instagram sprite-icon"></span
          ><span class="visuallyhidden">Instagram</span></a
        >
        <a
          *ngIf="socialMediaLinks?.YT || currentTerritoryId === null"
          id="social-5"
          class="nav__link"
          [href]="socialMediaLinks?.YT ?? 'https://www.youtube.com/sonypictures'"
          target="_blank"
          rel="noopener"
          ><span class="icn-youtube sprite-icon"></span
          ><span class="visuallyhidden">Youtube</span></a
        >
        <a
          *ngIf="socialMediaLinks?.TT"
          id="social-6"
          class="nav__link"
          [href]="socialMediaLinks?.TT"
          target="_blank"
          rel="noopener"
          ><span class="icn-tiktok sprite-icon"></span><span class="visuallyhidden">TikTok</span></a
        >
      </div>
    </div>
  </div>
</footer>